"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var safe_access_1 = __importDefault(require("safe-access"));
var js_logger_1 = __importDefault(require("js-logger"));
var nucleus_1 = require("@lifesize/nucleus");
var remoting_1 = require("../constants/remoting");
var app = __importStar(require("../constants/app"));
var pairing = __importStar(require("../constants/pairing"));
/**
 * Sends an action with its payload so it can be dispatched on the device remotely paired
 * @param {string} action A string representing the action type to be dispatched remotely
 * @param {*} payload An object containing information about the action be dispatched
 */
function send(action, payload) {
    if (payload === void 0) { payload = null; }
    return message(remoting_1.service.actions.sendAction, { action: action, payload: payload });
}
var CONFERENCE_START_RECORDING = nucleus_1.nucleusConstants.CONFERENCE_START_RECORDING, CONFERENCE_STOP_RECORDING = nucleus_1.nucleusConstants.CONFERENCE_STOP_RECORDING, HTTP_POST = nucleus_1.nucleusConstants.HTTP_POST, SET_LOCALE = nucleus_1.nucleusConstants.SET_LOCALE;
/**
 * Actions that can be sent from the remote to the display
 */
var sendToDisplay = {
    app: {
        toggleInCallPip: function (isVisible) {
            if (isVisible === void 0) { isVisible = null; }
            return send(app.actions.toggleInCallPip, isVisible);
        },
        togglePipPreview: function (isVisible) {
            if (isVisible === void 0) { isVisible = null; }
            return send(app.actions.togglePipPreview, isVisible);
        },
        togglePresentationPrompt: function (isVisible) {
            if (isVisible === void 0) { isVisible = null; }
            return send(app.actions.togglePresentationPrompt, isVisible);
        },
        changeVolumeInCall: function (value) {
            if (value === void 0) { value = 0.5; }
            return send(app.actions.changeVolumeInCall, value);
        },
        requestPinChange: function (pin) {
            if (pin === void 0) { pin = ''; }
            return send(pairing.actions.REQUEST_PIN_CHANGE, pin);
        },
        setLocale: function (languageId) {
            if (languageId === void 0) { languageId = 'en-US'; }
            return send(SET_LOCALE, { languageId: languageId });
        },
        /** Creates an action to be sent from the remote in order to stop the wireless presentation at the display */
        stopWirelessPresentation: function () { return send(remoting_1.service.wirelessActions.stop); },
        // start and stop hdmi/share prentation
        startHdmiPresentation: function () { return send(app.actions.startHdmiPresentation); },
        stopHdmiPresentation: function () { return send(app.actions.stopHdmiPresentation); },
        startSharePresentation: function () { return send(app.actions.startSharePresentation); },
        stopSharePresentation: function () { return send(app.actions.stopSharePresentation); },
        // select in-call video layout
        selectCallLayout: function (layout) {
            if (layout === void 0) { layout = ''; }
            return send(app.actions.selectCallLayout, layout);
        },
        //meeting notification
        //payload: { meetingStartPromptVisible: true|false, name: VMR_Meeting, time: '10:00 AM - 11:00 AM' }
        showMeetingStartPrompt: function (payload) { return send(app.actions.showMeetingStartPrompt, payload); },
        clearRaiseHandErrors: function () { return send(app.actions.clearRaiseHandErrors); },
        unlinkConnect: function (uuid) { return send(remoting_1.service.proxyActions.unlinkConnect, uuid); }
    },
    call: {
        add: function () { return send(remoting_1.service.proxyActions.add); },
        answer: function (media) {
            if (media === void 0) { media = {}; }
            return send(remoting_1.service.proxyActions.answer, media);
        },
        call: function (contact, media) { return send(remoting_1.service.proxyActions.call, { contact: contact, media: media }); },
        cancel: function (participant) {
            if (participant === void 0) { participant = null; }
            return send(remoting_1.service.proxyActions.cancelCall, participant);
        },
        clear: function () { return send(remoting_1.service.proxyActions.clearCall); },
        doNotDisturb: function (value) { return send(remoting_1.service.proxyActions.doNotDisturb, value); },
        end: function () { return send(remoting_1.service.proxyActions.end); },
        endAndAnswer: function () { return send(remoting_1.service.proxyActions.endAndAnswer); },
        ignore: function () { return send(remoting_1.service.proxyActions.ignore); },
        sendMeetingPin: function (s) { return send(remoting_1.service.proxyActions.sendMeetingPin, s); },
        sendDtmf: function (s) { return send(remoting_1.service.proxyActions.sendDtmf, s); },
        startRecording: function (owner) { return send(CONFERENCE_START_RECORDING, owner); },
        stopRecording: function () { return send(CONFERENCE_STOP_RECORDING); },
        endSip: function () { return send(app.actions.endSip); },
        raiseHand: function () { return send(remoting_1.service.proxyActions.raiseHand); },
        lowerOwnHand: function () { return send(remoting_1.service.proxyActions.lowerOwnHand); }
    },
    conference: {
        muteAll: function (shouldMute) { return send(remoting_1.service.moderatorActions.muteAll, shouldMute); },
        muteParticipant: function (participant, shouldMute) { return send(remoting_1.service.moderatorActions.muteParticipant, { participant: participant, shouldMute: shouldMute }); },
        removeParticipant: function (participant) { return send(remoting_1.service.moderatorActions.removeParticipant, participant); },
        endAll: function () { return send(remoting_1.service.moderatorActions.endAll); },
        stopPresentation: function () { return send(remoting_1.service.moderatorActions.stopPresentation); },
        lockMeeting: function () { return send(remoting_1.service.moderatorActions.lockMeeting); },
        unlockMeeting: function () { return send(remoting_1.service.moderatorActions.unlockMeeting); },
        lowerAllHands: function () { return send(remoting_1.service.moderatorActions.lowerAllHands); },
        lowerParticipantHand: function (participantId) { return send(remoting_1.service.moderatorActions.lowerParticipantHand, participantId); },
        selectParticipant: function (participant) { return send(remoting_1.service.moderatorActions.selectParticipant, participant); }
    },
    directory: {
        search: function (searchString, contactTypes) {
            if (contactTypes === void 0) { contactTypes = []; }
            return send(remoting_1.service.proxyActions.directorySearch, { searchString: searchString, contactTypes: contactTypes });
        },
        addFavorite: function (contact) { return send(remoting_1.service.proxyActions.addFavorite, contact); },
        removeFavorite: function (contact) { return send(remoting_1.service.proxyActions.removeFavorite, contact); },
        removeRecent: function (item) { return send(remoting_1.service.proxyActions.removeRecent, item); },
        fetchNext: function (filter, pageLoadSize) { return send(remoting_1.service.directoryActions.fetchNext, { filter: filter, pageLoadSize: pageLoadSize }); },
        fetchActiveMeetings: function () { return send(remoting_1.service.directoryActions.fetchActiveMeetings); }
    },
    /* far end camera actions */
    fecc: {
        panLeft: function () { return send(remoting_1.service.feccActions.panLeft); },
        panRight: function () { return send(remoting_1.service.feccActions.panRight); },
        zoomIn: function () { return send(remoting_1.service.feccActions.zoomIn); },
        zoomOut: function () { return send(remoting_1.service.feccActions.zoomOut); },
        tiltUp: function () { return send(remoting_1.service.feccActions.tiltUp); },
        tiltDown: function () { return send(remoting_1.service.feccActions.tiltDown); },
        panLeftStop: function () { return send(remoting_1.service.feccActions.panLeftStop); },
        panRightStop: function () { return send(remoting_1.service.feccActions.panRightStop); },
        zoomInStop: function () { return send(remoting_1.service.feccActions.zoomInStop); },
        zoomOutStop: function () { return send(remoting_1.service.feccActions.zoomOutStop); },
        tiltUpStop: function () { return send(remoting_1.service.feccActions.tiltUpStop); },
        tiltDownStop: function () { return send(remoting_1.service.feccActions.tiltDownStop); },
        /* moves to a given preset */
        moveToPreset: function (preset) { return send(remoting_1.service.feccActions.moveToPreset, preset); }
    },
    /* local device camera actions, */
    deviceCamera: {
        panLeft: function (camera) {
            if (camera === void 0) { camera = null; }
            return send(app.deviceCameraActions.panLeft, camera);
        },
        panRight: function (camera) {
            if (camera === void 0) { camera = null; }
            return send(app.deviceCameraActions.panRight, camera);
        },
        zoomIn: function (camera) {
            if (camera === void 0) { camera = null; }
            return send(app.deviceCameraActions.zoomIn, camera);
        },
        zoomOut: function (camera) {
            if (camera === void 0) { camera = null; }
            return send(app.deviceCameraActions.zoomOut, camera);
        },
        tiltUp: function (camera) {
            if (camera === void 0) { camera = null; }
            return send(app.deviceCameraActions.tiltUp, camera);
        },
        tiltDown: function (camera) {
            if (camera === void 0) { camera = null; }
            return send(app.deviceCameraActions.tiltDown, camera);
        },
        panLeftStop: function (camera) {
            if (camera === void 0) { camera = null; }
            return send(app.deviceCameraActions.panLeftStop, camera);
        },
        panRightStop: function (camera) {
            if (camera === void 0) { camera = null; }
            return send(app.deviceCameraActions.panRightStop, camera);
        },
        zoomInStop: function (camera) {
            if (camera === void 0) { camera = null; }
            return send(app.deviceCameraActions.zoomInStop, camera);
        },
        zoomOutStop: function (camera) {
            if (camera === void 0) { camera = null; }
            return send(app.deviceCameraActions.zoomOutStop, camera);
        },
        tiltUpStop: function (camera) {
            if (camera === void 0) { camera = null; }
            return send(app.deviceCameraActions.tiltUpStop, camera);
        },
        tiltDownStop: function (camera) {
            if (camera === void 0) { camera = null; }
            return send(app.deviceCameraActions.tiltDownStop, camera);
        },
        /* payload: { camera: 'Gems-Camera1', index: 1, name: 'Zoomed In' }*/
        setPreset: function (payload) { return send(app.deviceCameraActions.setPreset, payload); },
        /* payload: { camera: 'Gems-Camera1', index: 1, name: 'Zoomed In' }*/
        renamePreset: function (payload) { return send(app.deviceCameraActions.renamePreset, payload); },
        /* payload: { camera: 'Gems-Camera1', index: 0 }*/
        deletePreset: function (payload) { return send(app.deviceCameraActions.deletePreset, payload); },
        /* payload: { camera: 'Gems-Camera1', index: 0 }*/
        moveToPreset: function (payload) { return send(app.deviceCameraActions.moveToPreset, payload); }
    },
    stream: {
        toggleAudioMute: function (mute) {
            if (mute === void 0) { mute = null; }
            return send(remoting_1.service.proxyActions.toggleAudioMute, mute);
        },
        toggleVideoMute: function (mute) {
            if (mute === void 0) { mute = null; }
            return send(remoting_1.service.proxyActions.toggleVideoMute, mute);
        }
    },
    wireless: {
        answer: function (localDescription) { return sendWirelessPresentationMessage(remoting_1.service.wirelessActions.answer, localDescription); },
        end: function () { return sendWirelessPresentationMessage(remoting_1.service.wirelessActions.end); },
        ice: function (candidate) { return sendWirelessPresentationMessage(remoting_1.service.wirelessActions.ice, candidate); },
        offer: function (localDescription) { return sendWirelessPresentationMessage(remoting_1.service.wirelessActions.offer, localDescription); }
    },
    lifesizeConnect: {
        answer: function (localDescription) { return sendLifesizeConnectMessage(remoting_1.service.lifesizeConnectActions.answer, localDescription); },
        end: function () { return sendLifesizeConnectMessage(remoting_1.service.lifesizeConnectActions.end); },
        ice: function (candidate) { return sendLifesizeConnectMessage(remoting_1.service.lifesizeConnectActions.ice, candidate); },
        offer: function (localDescription) { return sendLifesizeConnectMessage(remoting_1.service.lifesizeConnectActions.offer, localDescription); }
    },
    dataChannel: {
        answer: function (localDescription) { return send(remoting_1.service.dataChannel.answer, localDescription); },
        end: function () { return send(remoting_1.service.dataChannel.end); },
        ice: function (candidate) { return send(remoting_1.service.dataChannel.ice, candidate); },
        offer: function (localDescription) { return send(remoting_1.service.dataChannel.offer, localDescription); }
    }
};
/**
 * Sends a subset of the state to the device remotely paired
 * @param {*} state An object representing the subset of the state to be sent
 * @param {boolean} isComplete Indicates if the whole state is being sent or just the difference between the last one sent
 */
function sendState(state, isComplete) {
    if (isComplete === void 0) { isComplete = false; }
    return message(remoting_1.service.actions.sendState, { state: state, isComplete: isComplete });
}
/**
 * Request a subset of the state to the device remotely paired
 * @param {string} uuid A string representing the UUID required to identify this device
 */
function requestState(uuid) {
    return message(remoting_1.service.actions.requestState, { from: uuid, value: true });
}
/**
 * Always triggered by the display, this action updates all of the authenticated presenters
 * @param {*} newRemoteState An object representing the subset of the state to be sent
 */
function sendPresenterState(newRemoteState) {
    return function (dispatch, getState) {
        var type = remoting_1.service.actions.sendState;
        var state = getState();
        var value = { state: newRemoteState };
        var targets = safe_access_1.default(state, 'app.remoting.pairing.presenters');
        var updates = targets.map(function (target) {
            dispatch(nucleus_1.proxyActions.proxyApiCall(remoting_1.service.name, '/', HTTP_POST, { target: target, type: type, value: value }));
        });
        return Promise.all(updates)
            .catch(function (err) { return js_logger_1.default.warn('Failed to update presenter.', err); })
            .then(function () { return js_logger_1.default.log('Presenters updated successfully.'); });
    };
}
function sendWirelessPresentationMessage(action, payload) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var state, type, value, target, isDisplay;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    type = remoting_1.service.actions.sendAction;
                    value = { action: action, payload: payload };
                    isDisplay = safe_access_1.default(state, 'app.remoting.pairing.isDisplay');
                    if (isDisplay) {
                        target = safe_access_1.default(state, 'app.remoting.pairing.activePresenter');
                        if (!target)
                            return [2 /*return*/];
                    }
                    return [4 /*yield*/, dispatch(nucleus_1.proxyActions.proxyApiCall(remoting_1.service.name, '/', HTTP_POST, { target: target, type: type, value: value }))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
}
function sendLifesizeConnectMessage(action, payload) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var state, type, value, target, isDisplay;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    type = remoting_1.service.actions.sendAction;
                    value = { action: action, payload: payload };
                    isDisplay = safe_access_1.default(state, 'app.remoting.pairing.isDisplay');
                    if (isDisplay) {
                        target = safe_access_1.default(state, 'app.remoting.pairing.activeConnecter');
                        if (!target)
                            return [2 /*return*/];
                    }
                    return [4 /*yield*/, dispatch(nucleus_1.proxyActions.proxyApiCall(remoting_1.service.name, '/', HTTP_POST, { target: target, type: type, value: value }))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
}
function message(type, value) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var state, dataChannelOpen, target;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    dataChannelOpen = safe_access_1.default(state, 'nucleus.dataChannel.open');
                    if (!dataChannelOpen) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch({ type: remoting_1.actions.DATA_CHANNEL_SEND_MESSAGE, payload: { type: type, value: value } })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 2:
                    if (!nucleus_1.servicesSelectors.selectConnected(state)) return [3 /*break*/, 4];
                    target = safe_access_1.default(state, 'app.remoting.pairing.pairedUuid');
                    return [4 /*yield*/, dispatch(nucleus_1.proxyActions.proxyApiCall(remoting_1.service.name, '/', HTTP_POST, { target: target, type: type, value: value }))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    js_logger_1.default.log("Remoting message " + type + " cannot be sent");
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
}
function displayPaired(payload) {
    return {
        type: pairing.actions.DISPLAY_PAIRED,
        payload: payload
    };
}
function displayUnpaired() {
    return { type: pairing.actions.DISPLAY_UNPAIRED };
}
function remoteStateUpdated(remoteState) {
    return { type: remoting_1.actions.REMOTE_STATE_UPDATED, payload: remoteState };
}
function subscribeToEvents() {
    return function (dispatch) { return dispatch(nucleus_1.proxyActions.subscribe(remoting_1.topics.graphiteTopic)); };
}
function unsubscribeFromEvents() {
    return function (dispatch) { return dispatch(nucleus_1.proxyActions.unsubscribe(remoting_1.topics.graphiteTopic)); };
}
function openDataChannel() {
    return function (dispatch) { return dispatch({ type: remoting_1.actions.DATA_CHANNEL_CREATE_OFFER }); };
}
function error(error) {
    return { type: remoting_1.actions.REMOTING_ERROR, payload: error };
}
exports.default = {
    displayPaired: displayPaired,
    displayUnpaired: displayUnpaired,
    error: error,
    message: message,
    openDataChannel: openDataChannel,
    remoteStateUpdated: remoteStateUpdated,
    requestState: requestState,
    send: send,
    sendPresenterState: sendPresenterState,
    sendState: sendState,
    sendToDisplay: sendToDisplay,
    subscribeToEvents: subscribeToEvents,
    unsubscribeFromEvents: unsubscribeFromEvents
};
